import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import { ExportTPL, LoadData, LoadMainData } from '@/api/ImportExcel';
import d2HeaderFullscreen from '@/layout/header-aside/components/header-fullscreen';
import { userService } from '@/api/service';
import { throttle } from 'lodash';
var cssObject = {
  'scroll-content': {
    position: 'relative',
    overflow: 'hidden'
  },
  'header-container': {
    transition: 'transform 0.3s',
    whiteSpace: 'nowrap',
    display: 'table-cell',
    verticalAlign: 'middle'
  },
  'is-scrollable': {
    position: 'relative',
    padding: '0 20px'
  },
  menu__prev: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    fontSize: '20px',
    width: '20px',
    cursor: 'pointer',
    color: '#ff929a',
    background: 'transparent'
  },
  menu__next: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    fontSize: '20px',
    width: '20px',
    cursor: 'pointer',
    color: '#ff929a',
    background: 'transparent'
  }
};
export default {
  name: 'custom-container-header',
  render: function render(h) {
    var _this = this;

    return h("div", {
      "style": this.isScroll ? cssObject['is-scrollable'] : {}
    }, [h("div", {
      "style": cssObject['scroll-content'],
      "ref": "scrollContent"
    }, [h("div", {
      "style": _objectSpread({
        transform: "translateX(".concat(this.currentTranslateX, "px)")
      }, cssObject['header-container']),
      "ref": "scrollHeader"
    }, [h("div", {
      "style": "display: flex;align-items: center;"
    }, [this.$slots.default].concat(_toConsumableArray(this.isImport && this.$btnList.indexOf(this.importBtnName) !== -1 ? [h('el-upload', {
      props: {
        accept: '.xls,.xlsx',
        action: '#',
        'file-list': this.fileList,
        limit: 20,
        // 'on-success': (response, file, fileList) => this.handleUploadSuccess(response, file, fileList),
        'show-file-list': false,
        'http-request': function httpRequest(data) {
          return _this.handleRequest(data);
        }
      },
      ref: 'customUpload',
      style: {
        margin: '0 10px'
      }
    }, [h('el-button', {
      props: {
        icon: 'el-icon-cloudy',
        size: 'small',
        type: 'primary'
      }
    }, this.$t('publics.btn.click_Import'))])] : []), [this.isExport && this.$btnList.indexOf(this.exportBtnName) !== -1 ? h("el-button", {
      "attrs": {
        "icon": "el-icon-s-order",
        "size": "small",
        "type": "info"
      },
      "on": {
        "click": function click() {
          return _this.handlerCallFunc();
        }
      }
    }, [this.$t('publics.btn.export_document')]) : '', this.isExportTpl && this.$btnList.indexOf(this.exportTplName) !== -1 ? h("el-button", {
      "attrs": {
        "icon": "el-icon-download",
        "size": "small",
        "type": "success"
      },
      "on": {
        "click": function click() {
          return _this.handleExportTpl();
        }
      }
    }, [this.$t('publics.btn.export_template')]) : '', this.isFull ? h("d2-header-fullscreen", {
      "style": "padding-left: 15px;padding-right: 20px"
    }) : '']))])]), this.isScroll ? h("div", [h("div", {
      "style": cssObject.menu__prev,
      "on": {
        "click": function click() {
          _this.scroll('left');
        }
      }
    }, [h("div", {
      "style": "display: flex;width: 100%;height: 100%;align-items: center;"
    }, [h("i", {
      "class": "el-icon-arrow-left"
    })])]), h("div", {
      "style": cssObject.menu__next,
      "on": {
        "click": function click() {
          return _this.scroll('right');
        }
      }
    }, [h("div", {
      "style": "display: flex;width: 100%;height: 100%;align-items: center;"
    }, [h("i", {
      "class": 'el-icon-arrow-right'
    })])])]) : '', this.isProgress ? h("transition", {
      "attrs": {
        "name": "el-fade-in-linear"
      }
    }, [h("div", {
      "class": "el-dialog__wrapper",
      "style": "z-index: 999"
    }, [h("div", {
      "style": "display: flex;align-items: center;justify-content: center;height: 100%"
    }, [h("el-progress", {
      "attrs": {
        "type": "circle",
        "percentage": this.progressPercent,
        "status": this.uploadStatus
      }
    })])])]) : '']);
  },
  data: function data() {
    return {
      isScroll: false,
      scrollWidth: 0,
      contentWidth: 0,
      currentTranslateX: 0,
      throttledCheckScroll: null,
      fileList: [],
      // uploadURl: process.env.VUE_APP_FILE_PATH + '/api/ImportExcel/ImportExcelFile',
      uploadURl: '',
      serviceUrl: null,
      tableNameObj: {},
      progressPercent: 0,
      uploadStatus: 'warning',
      isProgress: false,
      timer: null
    };
  },
  components: {
    d2HeaderFullscreen: d2HeaderFullscreen
  },
  props: {
    importBtnName: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    exportBtnName: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    exportTplName: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    // 默认加载数据方法名称
    defaultLoadDataMethodsName: {
      type: String,
      default: function _default() {
        return 'getLoadData';
      }
    },
    // 是否需要全屏
    isFull: {
      type: Boolean,
      default: false
    },
    // 是否需要导出模板
    isExportTpl: {
      type: Boolean,
      default: true
    },
    // 导出数据方法名称
    exportMehodsName: {
      type: String,
      default: 'getLoadData'
    },
    // 导入表名
    tableName: {
      // 废弃 采取接口形式
      type: String,
      default: ''
    },
    // 导出数据方法名称相关
    defaultTotalPage: {
      type: String,
      default: 'totalPage'
    },
    // 导出数据方法名称相关
    defaultMainTable: {
      type: String,
      default: 'mainTable'
    },
    // 导出数据方法名称相关
    defaultLoadingFlag: {
      type: String,
      default: 'loading'
    },
    // 导出数据方法名称相关
    defaultFormData: {
      type: String,
      default: 'formData'
    },
    // 是否显示导出按钮
    isExport: {
      type: Boolean,
      default: true
    },
    // 是否显示导入按钮
    isImport: {
      type: Boolean,
      default: true
    },
    // 默认导出table的ref
    defaultTableRefs: {
      type: String,
      default: 'xTable'
    } // uploadURl: {
    //   type: String,
    //   default: () => process.env.VUE_APP_FILE_PATH + '/api/ImportExcel/ImportExcelFile'
    // }

  },
  methods: {
    getOtherParams: function getOtherParams() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _res$Result;

        var _parent, routeName, tableName, arr, res, obj;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 获取tableName方法
                _parent = _this2.$parent.$parent.$parent;
                routeName = _parent.$route.name;
                tableName = '';
                arr = routeName.split('/');

                if (/^\//.test(routeName)) {
                  tableName = "".concat(arr[1], "/Index");
                } else {
                  tableName = "".concat(arr[0], "/Index");
                } // debugger


                _context.next = 7;
                return LoadMainData({
                  Page: 1,
                  Limit: 15,
                  TOTABLE_NAME: '',
                  DESC_CN: '',
                  DESC_EN: tableName,
                  Key: ''
                });

              case 7:
                res = _context.sent;
                obj = ((_res$Result = res.Result) === null || _res$Result === void 0 ? void 0 : _res$Result[0]) || {};
                _this2.tableNameObj = {
                  fileName: obj.DESC_CN,
                  table_name: obj.TOTABLE_NAME
                };

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleExportTpl: function handleExportTpl() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var tableName, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tableName = _this3.tableNameObj.table_name ? _this3.tableNameObj : _this3.getOtherParams();

                if (!(!tableName || !tableName.table_name)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                _context2.next = 5;
                return ExportTPL(tableName.table_name);

              case 5:
                res = _context2.sent;

                if (res.Result) {
                  window.open(_this3.serviceUrl + res.Result);

                  _this3.$notify.success({
                    title: _this3.$t('publics.tips.success'),
                    message: _this3.$t('publics.tips.successExportTpl')
                  });
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 获取全局导出数据
    handlerCallFunc: function handlerCallFunc() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _parent, tmpTotalPage, tmpMainTable, tmpFormData, limit, timeout, afterMainTable, tableName, res, T, excel, tHeader, fileList, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _parent = _this4.$parent.$parent.$parent;
                tmpTotalPage = _parent[_this4.defaultTotalPage];
                tmpMainTable = _parent[_this4.defaultMainTable];
                tmpFormData = _parent[_this4.defaultFormData];
                limit = _parent[_this4.defaultFormData].Limit;
                _parent[_this4.defaultFormData].Page = 1;
                _parent[_this4.defaultFormData].Limit = tmpTotalPage;
                timeout = userService.defaults.timeout; // 修改 axios 实例的默认配置

                userService.defaults.timeout = timeout * 1000;
                _context3.next = 11;
                return _parent[_this4.exportMehodsName]({
                  table_name: _this4.tableName
                });

              case 11:
                afterMainTable = _parent[_this4.defaultMainTable]; // 导出的数据

                userService.defaults.timeout = timeout;
                _parent[_this4.defaultFormData] = tmpFormData;
                _parent[_this4.defaultTotalPage] = tmpTotalPage;
                _parent[_this4.defaultMainTable] = tmpMainTable; // 导出excel

                tableName = _this4.tableNameObj.table_name || _this4.getOtherParams().table_name;
                _context3.next = 19;
                return LoadData(tableName);

              case 19:
                res = _context3.sent;
                _parent[_this4.defaultFormData].Limit = limit;

                if (!(res.Result && res.Result.ImportDtlList && res.Result.ImportDtlList.length)) {
                  _context3.next = 31;
                  break;
                }

                T = res.Result.ImportDtlList;
                _context3.next = 25;
                return import('@/vender/Export2Excel');

              case 25:
                excel = _context3.sent;
                tHeader = T.sort(function (currentItem, nextItem) {
                  return currentItem.EXCEL_ITEM > nextItem.EXCEL_ITEM ? 1 : -1;
                }).map(function (item) {
                  return item.COLUMN_CAPTION;
                });
                fileList = T.map(function (item) {
                  return !item.EXPORT_COLUMN_NAME ? item.COLUMN_NAME.toCamel() : item.EXPORT_COLUMN_NAME;
                });
                data = [];
                afterMainTable.map(function (item) {
                  var tmpArr = [];
                  fileList.map(function (_item) {
                    tmpArr.push(item[_item]);
                  });
                  data.push(tmpArr);
                });
                excel.export_json_to_excel({
                  header: tHeader,
                  data: data,
                  filename: _this4.tableNameObj.fileName || _parent.$route.meta.title,
                  autoWidth: true,
                  bookType: 'xlsx'
                });

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      var _response$ErrorInfo;

      // 上传成功回调 已废弃 =============
      if ((_response$ErrorInfo = response.ErrorInfo) !== null && _response$ErrorInfo !== void 0 && _response$ErrorInfo.Status) {
        var _response$ErrorInfo2;

        this.$message.error(((_response$ErrorInfo2 = response.ErrorInfo) === null || _response$ErrorInfo2 === void 0 ? void 0 : _response$ErrorInfo2.Message) || this.$t('publics.tips.handleFail'));
        return false;
      }

      if (response.Result) {
        this.$notify.success({
          title: this.$t('publics.tips.success'),
          message: this.$t('publics.tips.uploadSuccess')
        });
        var _parent = this.$parent.$parent.$parent;
        _parent[this.defaultFormData].Page = 1;

        _parent[this.defaultLoadDataMethodsName]();
      } else {
        this.$notify.error({
          title: this.$t('publics.tips.fail'),
          message: this.$t('publics.tips.uploadFail')
        });
      }
    },
    // 自定义上传
    handleRequest: function handleRequest(data) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var formdata, res, _parent;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                formdata = new FormData();
                formdata.append('file', data.file);
                formdata.append('fileName', data.file.name);
                formdata.append('table_name', _this5.tableNameObj.table_name || _this5.getOtherParams().table_name);
                _this5.isProgress = true;
                _this5.uploadStatus = 'warning';
                _context4.next = 8;
                return userService.post(_this5.uploadURl, formdata, {
                  onUploadProgress: function onUploadProgress(progressEvent) {
                    // progressEvent.loaded:已上传文件大小
                    // progressEvent.total:被上传文件的总大小
                    _this5.progressPercent = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2));
                  }
                }).catch(function (_) {
                  _this5.timer = setTimeout(function () {
                    _this5.isProgress = false;
                    clearTimeout(_this5.timer);
                  }, 1000);
                });

              case 8:
                res = _context4.sent;

                if (res.Result) {
                  _this5.uploadStatus = 'success';

                  _this5.$notify.success({
                    title: _this5.$t('publics.tips.success'),
                    message: _this5.$t('publics.tips.uploadSuccess')
                  });

                  _parent = _this5.$parent.$parent.$parent;
                  _parent[_this5.defaultFormData].Page = 1;

                  _parent[_this5.defaultLoadDataMethodsName]();
                } else {
                  _this5.uploadStatus = 'exception';

                  _this5.$notify.error({
                    title: _this5.$t('publics.tips.fail'),
                    message: _this5.$t('publics.tips.uploadFail')
                  });
                }

                _this5.timer = setTimeout(function () {
                  _this5.isProgress = false;
                  clearTimeout(_this5.timer);
                }, 1000);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    checkScroll: function checkScroll() {
      var _this6 = this;

      var contentWidth = this.$refs.scrollContent.clientWidth;
      var scrollWidth = this.$refs.scrollHeader.clientWidth;

      if (this.isScroll) {
        // 页面依旧允许滚动的情况，需要更新width
        if (this.contentWidth - this.scrollWidth === this.currentTranslateX) {
          // currentTranslateX 也需要相应变化【在右端到头的情况时】
          this.currentTranslateX = contentWidth - scrollWidth; // 快速的滑动依旧存在判断和计算时对应的contentWidth变成正数，所以需要限制一下

          if (this.currentTranslateX > 0) {
            this.currentTranslateX = 0;
          }
        } // 更新元素数据


        this.contentWidth = contentWidth;
        this.scrollWidth = scrollWidth; // 判断何时滚动消失: 当scroll > content

        if (contentWidth > scrollWidth) {
          this.isScroll = false;
        }
      } // 判断何时滚动出现: 当scroll < content


      if (!this.isScroll && contentWidth < scrollWidth) {
        this.isScroll = true; // 注意，当isScroll变为true，对应的元素盒子大小会发生变化

        this.$nextTick(function () {
          contentWidth = _this6.$refs.scrollContent.clientWidth;
          scrollWidth = _this6.$refs.scrollHeader.clientWidth;
          _this6.contentWidth = contentWidth;
          _this6.scrollWidth = scrollWidth;
          _this6.currentTranslateX = 0;
        });
      }
    },
    scroll: function scroll(direction) {
      if (direction === 'left') {
        // 向右滚动
        this.currentTranslateX = 0;
      } else {
        // 向左滚动
        if (this.contentWidth * 2 - this.currentTranslateX <= this.scrollWidth) {
          this.currentTranslateX -= this.contentWidth;
        } else {
          this.currentTranslateX = this.contentWidth - this.scrollWidth;
        }
      }
    }
  },
  created: function created() {
    var _this7 = this;

    this.uploadURl = this.$store.getters.getVUE_APP_FILE_PATH + '/api/ImportExcel/ImportExcelFile';
    this.serviceUrl = this.$store.getters.getVUE_APP_FILE_PATH;
    this.getOtherParams();
    this.$parent.$parent.$nextTick(function () {
      _this7.checkScroll();
    }); // 默认判断父元素和子元素的大小，以确定初始情况是否显示滚动

    window.addEventListener('load', this.checkScroll); // 全局窗口变化监听，判断父元素和子元素的大小，从而控制isScroll的开关

    this.throttledCheckScroll = throttle(this.checkScroll, 300);
    window.addEventListener('resize', this.throttledCheckScroll);
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.timer); // 取消监听

    window.removeEventListener('resize', this.throttledCheckScroll);
    window.removeEventListener('load', this.checkScroll);
  }
};